import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useScrollToTop } from '../hooks/useScrollToTop';
import { drumTeacher } from '../assets';

const Instructors: React.FC = () => {
  const { t } = useLanguage();

  // 페이지 마운트 시 상단으로 스크롤
  useScrollToTop();

  return (
    <div className="instructors-page">
      <div className="page-header">
        <div className="page-badge">Instructors</div>
        <h1 className="page-title">{t('instructors_title')}</h1>
        <p className="page-description">{t('instructors_description')}</p>
      </div>

      <div className="page-content">
        <div className="container">

          <div className="form-container">
            <div className="instructor-intro-section">
              <div className="intro-content">
                <div className="instructor-profile">
                  <img src={drumTeacher} alt="Drum Teacher" className="instructor-image" />
                  <div className="instructor-info">
                    <h2>{t('instructor_greeting')}</h2>
                    <p className="intro-text">{t('instructor_intro_text_1')}</p>
                    <p className="intro-text">{t('instructor_intro_text_2')}</p>
                    <p className="intro-text">{t('instructor_intro_text_3')}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="features-section">
              <div className="section-header">
                <div className="section-label">Features</div>
                <h2 className="section-title">{t('why_choose_dream_drums')}</h2>
              </div>
              <div className="features-grid">
                <div className="feature-card">
                  <h3>{t('one_on_one_curriculum')}</h3>
                  <p>{t('one_on_one_curriculum_desc')}</p>
                </div>
                <div className="feature-card">
                  <h3>{t('beyond_drum_lessons')}</h3>
                  <p>{t('beyond_drum_lessons_desc')}</p>
                </div>
                <div className="feature-card">
                  <h3>{t('no_boring_lessons')}</h3>
                  <p>{t('no_boring_lessons_desc')}</p>
                </div>
              </div>
            </div>

            <div className="instructor-background-section">
              <div className="section-header">
                <div className="section-label">Background</div>
                <h2 className="section-title">{t('instructor_background_title')}</h2>
              </div>
              <div className="background-content">
                <ul className="background-list">
                  <li>{t('background_1')}</li>
                  <li>{t('background_2')}</li>
                  <li>{t('background_3')}</li>
                  <li>{t('background_4')}</li>
                  <li>{t('background_5')}</li>
                  <li>{t('background_6')}</li>
                  <li>{t('background_7')}</li>
                  <li>{t('background_8')}</li>
                  <li>{t('background_9')}</li>
                  <li>{t('background_10')}</li>
                  <li>{t('background_11')}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instructors;
